import { t } from '@lingui/macro';
import { DimensionLine } from '~/app/shared/dimensions/types';

export const validateDimensionValueId = (value: number | undefined, lines: DimensionLine[] | undefined) => {
    if (typeof lines === 'undefined') {
        return undefined;
    }

    if (typeof value === 'number' && ![null, ...lines.map(l => l.key)].includes(value)) {
        return t`Invalid dimension value`;
    }

    return undefined;
};
